import { SEVERITY_MAP } from '@/constants/common'
import * as R from 'ramda'
import { IMPACT } from '@/constants/idea'

/**
 * This function sorts the input *ideas* based on *by*. The order is determined by *direction*
 * @param ideas
 * @param by - priority | dueDate | title | owner
 * @param direction - ascending | descending
 * @returns {ideas[]}
 */
export default function(ideas, { by, direction }) {
  const directionFunc = direction === 'ascending' ? R.ascend : R.descend
  const sortByDueDateAscend = R.ascend(idea => (idea.dueDate ? new Date(idea.dueDate) : Infinity))
  const sortByImpactDescend = R.descend(idea => IMPACT[idea.impact].severity)
  let sortedIdeas = ideas
  if (['impact', 'effort', 'reach'].includes(by)) {
    sortedIdeas = R.sortWith(
      [directionFunc(idea => SEVERITY_MAP[idea[by]].severity), sortByDueDateAscend],
      ideas
    )
  } else if (by === 'dueDate') {
    const [withDueDate, withoutDueDate] = R.partition(idea => idea.dueDate, ideas)
    sortedIdeas = R.sortWith(
      [directionFunc(idea => new Date(idea.dueDate)), sortByImpactDescend],
      withDueDate
    )
    sortedIdeas = [...sortedIdeas, ...withoutDueDate]
  } else if (by === 'owner') {
    const [withOwner, withoutOwner] = R.partition(
      idea => idea.ownerships.find(R.propEq('isPrimary', true)),
      ideas
    )
    sortedIdeas = R.sortWith(
      [
        directionFunc(idea => {
          const owner = idea.ownerships.find(R.propEq('isPrimary', true))
          const user = this.$store.getters.userById(owner.userId)
          return user && user.displayName.toLowerCase()
        }),
        sortByDueDateAscend,
        sortByImpactDescend
      ],
      withOwner
    )
    sortedIdeas = [...sortedIdeas, ...withoutOwner]
  } else {
    const comparator = directionFunc(
      R.compose(
        R.toLower,
        R.prop(by)
      )
    )
    sortedIdeas = R.sort(comparator, ideas)
  }
  return sortedIdeas
}
